"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteList = void 0;
const Kette_1 = require("./Kette");
const ArticleList_1 = require("../ArticleList");
const ArticleUtils_1 = require("../ArticleUtils");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const KetteUtil_1 = require("./KetteUtil");
/**
 * The `KetteList` manages a list of `Kette`
 */
class KetteList extends ArticleList_1.ArticleList {
    constructor() {
        super();
    }
    static fromScratch() {
        return new KetteList();
    }
    static fromJson(json, cloneStrategy = 'deep') {
        const list = new KetteList();
        list.fromJson(json, cloneStrategy);
        return list;
    }
    static fromModel(model) {
        const list = new KetteList();
        list.fromModel(model);
        return list;
    }
    static fromArray(arr) {
        const list = new KetteList();
        list.fromArray(arr);
        return list;
    }
    // SEARCH
    static filterByArtNrCountry(ketten, artNrCountry) {
        return ketten.filter((article) => article.ArtNr && article.ArtNr[artNrCountry]);
    }
    static filterBySerieId(ketten, id) {
        return ketten.filter((k) => { var _a; return ((_a = k.SerieRef) === null || _a === void 0 ? void 0 : _a.Id) === id; });
    }
    /*
     * Retrieves a new KetteList filtered by serie Kuerzel
     * @returns A new KetteList
     */
    static filterByKuerzel(ketten, kuerzel) {
        if (!kuerzel)
            return ketten;
        return ketten.filter((item) => { var _a; return ((_a = item.SerieRef) === null || _a === void 0 ? void 0 : _a.Kuerzel) && item.SerieRef.Kuerzel.toUpperCase() === kuerzel.toUpperCase(); });
    }
    /*
     * Retrieves a new KetteList filtered by IndexBreite
     * @returns A new KetteList
     */
    static filterByIndexBreite(ketten, indexBreite) {
        if (!indexBreite)
            return [];
        return ketten.filter((item) => item.IndexBreite != null && item.IndexBreite.toUpperCase() === indexBreite.toUpperCase());
    }
    /*
     * Retrieves a new KetteList filtered by IndexBiegeradius
     * @returns A new KetteList
     */
    static filterByIndexBiegeradius(ketten, indexBiegeradius) {
        if (!indexBiegeradius)
            return [];
        return ketten.filter((item) => String(item.IndexBiegeradius).toUpperCase() === indexBiegeradius.toUpperCase());
    }
    /*
     * Retrieves a new KetteList filtered by IndexBiegeradius Radius
     * @returns A new KetteList
     */
    static filterByIndexBiegeradiusR(ketten, indexBiegeradiusR) {
        if (!indexBiegeradiusR)
            return [];
        return ketten.filter((item) => KetteUtil_1.KetteUtil.splitBiegeradiusIntoRAndRbr(item.IndexBiegeradius).r.toUpperCase() ===
            (indexBiegeradiusR === null || indexBiegeradiusR === void 0 ? void 0 : indexBiegeradiusR.toUpperCase()));
    }
    /*
     * Retrieves a new KetteList filtered by IndexBiegeradius Rückwärtiger Biegeradius
     * @returns A new KetteList
     */
    static filterByIndexBiegeradiusRbr(ketten, indexBiegeradiusRbr) {
        if (!indexBiegeradiusRbr)
            return [];
        return ketten.filter((item) => KetteUtil_1.KetteUtil.splitBiegeradiusIntoRAndRbr(item.IndexBiegeradius).rbr.toUpperCase() ===
            indexBiegeradiusRbr.toUpperCase());
    }
    /*
     * Retrieves a new KetteList filtered by RadiusAussen in mm
     * @returns A new KetteList
     */
    static filterByRadiusAussen(ketten, radiusAussenMm) {
        if (radiusAussenMm == null)
            return [];
        return ketten.filter((item) => {
            var _a, _b;
            const lengthMm = (_a = item.RadiusAussen_mm) !== null && _a !== void 0 ? _a : (_b = echain_shared_quantities_1.Q.optional(item.RadiusAussen)) === null || _b === void 0 ? void 0 : _b.mm;
            // eslint-disable-next-line eqeqeq
            return lengthMm == radiusAussenMm;
        });
    }
    static filterByRotationswinkel(ketten, rotationswinkelDeg) {
        if (rotationswinkelDeg == null)
            return [];
        return ketten.filter((item) => {
            var _a, _b;
            const angleDeg = (_a = item.Rotationswinkel_deg) !== null && _a !== void 0 ? _a : (_b = echain_shared_quantities_1.Q.optional(item.Rotationswinkel)) === null || _b === void 0 ? void 0 : _b.deg;
            // eslint-disable-next-line eqeqeq
            return angleDeg == rotationswinkelDeg;
        });
    }
    static getAllSerieKuerzel(ketten) {
        const allSerieKuerzel = new Set();
        for (const item of ketten) {
            if (!item.SerieRef)
                continue;
            const kuerzel = item.SerieRef.Kuerzel;
            if (kuerzel) {
                allSerieKuerzel.add(kuerzel);
            }
        }
        return Array.from(allSerieKuerzel);
    }
    static getAllIndexBreite(ketten) {
        const allIndexBreite = new Set();
        for (const item of ketten) {
            if (!item.IndexBreite)
                continue;
            allIndexBreite.add(item.IndexBreite);
        }
        return Array.from(allIndexBreite);
    }
    static getAllRadiusAussen(ketten) {
        const allRadiusAussenMm = new Set();
        ketten.forEach((item) => {
            var _a, _b;
            const lengthMm = (_a = item.RadiusAussen_mm) !== null && _a !== void 0 ? _a : (_b = echain_shared_quantities_1.Q.optional(item.RadiusAussen)) === null || _b === void 0 ? void 0 : _b.mm;
            if (lengthMm == null)
                return;
            allRadiusAussenMm.add(lengthMm);
        });
        return Array.from(allRadiusAussenMm).map((mm) => {
            return echain_shared_quantities_1.Length.mm(mm);
        });
    }
    static getAllRotationswinkel(ketten) {
        const allRotationswinkelDeg = new Set();
        ketten.forEach((item) => {
            var _a, _b;
            const angleDeg = (_a = item.Rotationswinkel_deg) !== null && _a !== void 0 ? _a : (_b = echain_shared_quantities_1.Q.optional(item.Rotationswinkel)) === null || _b === void 0 ? void 0 : _b.deg;
            if (angleDeg == null)
                return;
            allRotationswinkelDeg.add(angleDeg);
        });
        return Array.from(allRotationswinkelDeg).map((deg) => {
            return echain_shared_quantities_1.Angle.deg(deg);
        });
    }
    static getAllIndexBiegeradiusR(ketten) {
        const allR = new Set();
        for (const item of ketten) {
            const r = KetteUtil_1.KetteUtil.splitBiegeradiusIntoRAndRbr(item.IndexBiegeradius).r;
            if (!r)
                continue;
            allR.add(r);
        }
        return Array.from(allR);
    }
    static getAllIndexBiegeradiusRbr(ketten) {
        const allRbr = new Set();
        for (const item of ketten) {
            const rbr = KetteUtil_1.KetteUtil.splitBiegeradiusIntoRAndRbr(item.IndexBiegeradius).rbr;
            if (!rbr)
                continue;
            allRbr.add(rbr);
        }
        return Array.from(allRbr);
    }
    static filterByArtNr(ketten, artNr) {
        return ketten.filter((item) => {
            return String(ArticleUtils_1.ArticleUtils.getQuoteArtNr(item)).toUpperCase() === String(artNr).toUpperCase();
        });
    }
    fromJson(json, cloneStrategy = 'deep') {
        const items = json.map((j) => Kette_1.Kette.fromJson(j, cloneStrategy));
        // @ts-ignore
        this.items = items;
        this.model = this.items.map((i) => i.toModel());
        this.emitChange();
    }
    fromModel(model) {
        const items = model.map((m) => Kette_1.Kette.fromModel(m));
        // @ts-ignore
        this.items = items;
        this.model = model;
        this.emitChange();
    }
    toJson() {
        return this.items.map((i) => i.toJson());
    }
    toModel() {
        return this.model;
    }
    clone() {
        return KetteList.fromArray(this.items.map((i) => i.clone()));
    }
    group(options) {
        return ArticleUtils_1.ArticleUtils.groupArticles(this.items, options);
    }
    /**
     * States if the list contains any e-skin chain
     */
    hasESkin() {
        return this.items.some((k) => k.isSerieESkin());
    }
    static hasESkin(ketten) {
        return ketten.some((k) => KetteUtil_1.KetteUtil.isSerieESkin(k));
    }
    /**
     * States if the list contains any rx-rohre
     */
    hasRxRohre() {
        return this.items.some((k) => k.isSerieRxRohr());
    }
    /**
     * States if the list contains any twisterband chain
     */
    hasTwisterband() {
        return this.items.some((k) => k.isSerieTwisterband());
    }
    /**
     * States if the list contains any twisterband chain
     */
    hasTwisterchain() {
        return this.items.some((k) => k.isSerieTwisterchain());
    }
    /**
     * States if the list contains any triflex chain
     */
    hasTriflex() {
        return this.items.some((k) => k.isSerieTriflexR());
    }
    /**
     * States if the list contains any trxe chain
     */
    hasTrxe() {
        return this.items.some((k) => k.isSerieTrxe());
    }
    /**
     * States if the list contains any rolEchain
     */
    hasRolLink() {
        return this.items.some((k) => k.isSerieRolEchain());
    }
}
exports.KetteList = KetteList;
//# sourceMappingURL=KetteList.js.map